import React, {Component} from 'react';
import {Row, Col, FormControl, ControlLabel} from "react-bootstrap";
import {TopButtonAdd, TopButtonPointAction, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import Validator from "../../../../../utilities/Validator";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";

export default class KierowcyEkipaCompontent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nowykierowca:null,
            nowazmiana:1,
        };
        this.renderItem = this.renderItem.bind(this)
        this.onClickZapiszZmiane = this.onClickZapiszZmiane.bind(this)
        this.onChangeNowyKierowca = this.onChangeNowyKierowca.bind(this)
        this.onChangeNowaZmiana = this.onChangeNowaZmiana.bind(this)
        this.onClickDodajNowy = this.onClickDodajNowy.bind(this)
    }

    onChangeNowyKierowca(e){
        this.setState({nowykierowca:e})
    }

    onChangeNowaZmiana(e){
        this.setState({nowazmiana:e.target.value})
    }

    onClickDodajNowy(){
        if(Boolean(this.state.nowazmiana) && Validator.validateInt(this.state.nowazmiana) && Boolean(this.state.nowykierowca)){
            let data = {
                "idTmSt": this.props.ekipa.idTmSt,
                "idEkSt": this.props.ekipa.idEkSt,
                "idKiSt": this.state.nowykierowca.idKiSt,
                "idEk": this.props.ekipa.idEk,
                "idKi": this.state.nowykierowca.idKi,
                "zmiana": this.state.nowazmiana
            }
            this.props.handleClickDodaj(data)
            this.setState({
                nowykierowca:null,
                nowazmiana:1,
            })
            document.getElementById('inputNowaZmiana').value = 1;
        }
        else{
            alert('Proszę uzupełnić wszystkie dane (wybór kierowcy oraz zmiany) przy dodawaniu nowego kierowcy')
        }
    }

    onClickZapiszZmiane(obj){

        let input = document.getElementById('ekk-'+obj.idEkk)
        if(Boolean(input)){
            if(Validator.validateInt(input.value)){
                let data = {
                    "idEkk":obj.idEkk,
                    "idEk": obj.idEk,
                    "idEkSt": obj.idEkSt,
                    "idKi": obj.idKi,
                    "idKiSt": obj.idKiSt,
                    "zmiana": input.value
                }

                this.props.handleClickEdytuj(data)
            }
            else{
                input.style.borderColor = 'firebrick'
                setTimeout(function () {
                    input.style.borderColor = '#ccc'
                },1500)
            }
        }
    }

    renderItem(item){
        let kierowca = this.props.kierowcy.find(k=>k.idKi===item.idKi)
        if(Boolean(kierowca)){
            return(<div>
                <Row style={{marginTop:'5px'}}>
                    <Col xs={12} lg={5}>
                        <ControlLabel style={{marginBottom:'0px', lineHeight:'34px'}}>{kierowca.imie+' '+kierowca.nazwisko}</ControlLabel>
                    </Col>
                    <Col xs={6} lg={2}>
                        <FormControl type={'number'} defaultValue={Boolean(item.zmiana)? item.zmiana:''} bsSize={'xs'} id={'ekk-'+item.idEkk}/>
                    </Col>
                    <Col xs={6} lg={3}>
                            <TopButtonPointAction buttonIcon={'fa fa-save'} onClick={()=>{this.onClickZapiszZmiane(item)}} titleContent={'Zapisz numer zmiany'}/>
                            <TopButtonPointRemove onClick={()=>{this.props.handleClickUsun(item)}} titleContent={'Usuń kierowcę z tej ekipy'}/>
                    </Col>
                </Row>
            </div>)
        }

    }

    renderKierowcaSelect(option){
        return (
            <div>
                <span>{option.kierowcaInfo}</span>
                <div className={'pull-right'}>
                    {
                        Boolean(option.status)?
                            <span style={{color:'forestgreen',fontSize:'12px'}}><i className={'fa fa-check'}></i> aktywny</span>
                            :
                            <span style={{color:'firebrick',fontSize:'12px'}}><i className={'fa fa-times'}></i> nieaktywny</span>
                    }
                </div>
            </div>
        )
    }

    render() {
        return (
            <div style={{marginTop:'15px'}}>
                <h6 style={{color:'grey',fontSize:'16px'}}>
                    <i className={'fa fa-group'}></i> Kierowcy
                </h6>
                <Row>
                    <Col xs={12}>
                        <Row style={{marginTop:'5px',marginBottom:'5px', color:'grey',fontStyle:'italic'}}>
                            <Col xs={12} lg={5}>
                                <div style={{borderBottom:'1px solid #ddd'}}>
                                Imie i nazwisko
                                </div>
                            </Col>
                            <Col xs={6} lg={2}>
                                <div style={{borderBottom:'1px solid #ddd'}}>
                                Zmiana
                                </div>
                            </Col>
                            <Col xs={6} lg={2}>
                                <div style={{borderBottom:'1px solid #ddd'}}>
                                Akcje
                                </div>
                            </Col>
                        </Row>
                        {
                            this.props.kierowcyWEkipie.map(item=>{
                            return this.renderItem(item)
                        })}
                        <Row style={{marginTop:'15px'}}>
                            <Col xs={12} lg={5}>
                                <TopSelect onChange={this.onChangeNowyKierowca} value={this.state.nowykierowca} options={this.props.kierowcy}
                                           valueKey={'idKi'} labelKey={'kierowcaInfo'} placeholder={'Szukaj po imie nazwisko pesel...'}
                                            optionRenderer={this.renderKierowcaSelect} valueRenderer={this.renderKierowcaSelect}
                                />
                            </Col>
                            <Col xs={6} lg={2}>
                                <FormControl type={'number'} onChange={this.onChangeNowaZmiana} defaultValue={1} id={"inputNowaZmiana"}/>
                            </Col>
                            <Col xs={6} lg={4}>
                                <TopButtonAdd onClick={this.onClickDodajNowy} text={'Dodaj kierowcę do ekipy'}/>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipa/components/KierowcyEkipaCompontent.js